import type { SelectOption } from "@cinnamon/design-system/types";

export const CONVERT_DATE_FORMAT_OPTIONS: SelectOption[] = [
  { value: "yyyymmdd", label: "yyyymmdd" },
  { value: "yyyy/mm/dd", label: "yyyy/mm/dd" },
  { value: "yyyy年mm月dd日", label: "yyyy年mm月dd日" },
  { value: "(年号)yy年mm月dd日", label: "(年号)yy年mm月dd日" },
];
